// import React, { useRef, useState } from "react";
// import MemberList from "./MemberList";
// import RegisterMember from "./RegisterMember";
// import TransferMember from "./TransferMember";
// import BulkMemberUploadModal from "./BulkMemberUploadModal";
// import "./members.css";

// export default function MembersPage() {
//   const [activeTab, setActiveTab] = useState("list");
//   const [showCreate, setShowCreate] = useState(false);
//   const [showBulk, setShowBulk] = useState(false);
//   const listRef = useRef(null);

//   const handleMemberCreated = async () => {
//     setShowCreate(false);
//     if (listRef.current?.reloadMembers) {
//       listRef.current.reloadMembers();
//     }
//   };

//   const handleBulkDone = async () => {
//     if (listRef.current?.reloadMembers) {
//       listRef.current.reloadMembers();
//     }
//   };

//   return (
//     <div className="page-container">
      
//       {/* Subtitle */}
//       {/* <div style={{ marginTop: "10px" }}>
//         <p className="subtitle">Manage and register church members</p>
//       </div> */}
//       {/* Header with Tabs on left, Buttons on right */}
//       <div
//         className="hierarchy-header"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap", // ensures mobile responsiveness
//           gap: "10px"
//         }}
//       >
//         {/* Left side: Tabs */}
//         <div style={{ display: "flex", gap: "10px" }}>
//           <button
//             className={`tab ${activeTab === "list" ? "active" : ""}`}
//             onClick={() => setActiveTab("list")}
//           >
//             Member List
//           </button>

//           <button
//             className={`tab ${activeTab === "transfer" ? "active" : ""}`}
//             onClick={() => setActiveTab("transfer")}
//           >
//             Transfer
//           </button>
//         </div>

//         {/* Right side: Action buttons */}
//         <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//           {activeTab === "list" && (
//             <>
//               <button className="btn primary" onClick={() => setShowBulk(true)}>
//                 Bulk Upload
//               </button>

//               <button className="btn primary" onClick={() => setShowCreate(true)}>
//                 + Add Member
//               </button>
//             </>
//           )}
//         </div>
//       </div>


//       {/* Tab Content */}
//       <div className="tab-content">
//         {activeTab === "list" && <MemberList ref={listRef} />}
//         {activeTab === "transfer" && <TransferMember />}
//       </div>

//       {/* Register Member Modal */}
//       {showCreate && (
//         <div className="modal-overlay">
//           <div
//             className="modal"
//             style={{ width: "95%", maxWidth: "1100px", maxHeight: "90vh" }}
//           >
//             <div className="modal-close" onClick={() => setShowCreate(false)}>
//               ✕
//             </div>
//             <RegisterMember
//               onSuccess={handleMemberCreated}
//               onClose={() => setShowCreate(false)}
//             />
//           </div>
//         </div>
//       )}

//       {/* Bulk Upload Modal */}
//       {showBulk && (
//         <BulkMemberUploadModal
//           onClose={() => setShowBulk(false)}
//           onSuccess={handleBulkDone}
//         />
//       )}
//     </div>
//   );
// }

import React, { useRef, useState } from "react";
import { getCurrentUser } from "../../services/auth";
import MemberList from "./MemberList";
import RegisterMember from "./RegisterMember";
import TransferMember from "./TransferMember";
import BulkMemberUploadModal from "./BulkMemberUploadModal";
import "./members.css";

export default function MembersPage() {
  const user = getCurrentUser();
  const isParokiaAdmin = user?.role === "PAROKIA_ADMIN";

  const [activeTab, setActiveTab] = useState("list");
  const [showCreate, setShowCreate] = useState(false);
  const [showBulk, setShowBulk] = useState(false);
  const listRef = useRef(null);

  const handleMemberCreated = async () => {
    setShowCreate(false);
    if (listRef.current?.reloadMembers) {
      listRef.current.reloadMembers();
    }
  };

  const handleBulkDone = async () => {
    if (listRef.current?.reloadMembers) {
      listRef.current.reloadMembers();
    }
  };

  return (
    <div className="page-container">
      {/* Header with Tabs on left, Buttons on right */}
      <div
        className="hierarchy-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        {/* Left side: Tabs */}
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            className={`tab ${activeTab === "list" ? "active" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            Member List
          </button>

          <button
            className={`tab ${activeTab === "transfer" ? "active" : ""}`}
            onClick={() => setActiveTab("transfer")}
          >
            Transfer
          </button>
        </div>

        {/* Right side: Action buttons - ONLY PAROKIA ADMIN */}
        {/* {isParokiaAdmin && (
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {activeTab === "list" && (
              <>
                <button className="btn primary" onClick={() => setShowBulk(true)}>
                  Bulk Upload
                </button>

                <button className="btn primary" onClick={() => setShowCreate(true)}>
                  + Add Member
                </button>
              </>
            )}
          </div>
        )} */}
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {activeTab === "list" && (
              <>
                <button className="btn primary" onClick={() => setShowBulk(true)}>
                  Bulk Upload
                </button>

                <button className="btn primary" onClick={() => setShowCreate(true)}>
                  + Add Member
                </button>
              </>
            )}
          </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "list" && <MemberList ref={listRef} />}
        {activeTab === "transfer" && <TransferMember />}
      </div>

      {/* Register Member Modal */}
      {showCreate && (
        <div className="modal-overlay">
          <div
            className="modal"
            style={{ width: "95%", maxWidth: "1100px", maxHeight: "90vh" }}
          >
            <div className="modal-close" onClick={() => setShowCreate(false)}>
              ✕
            </div>
            <RegisterMember
              onSuccess={handleMemberCreated}
              onClose={() => setShowCreate(false)}
            />
          </div>
        </div>
      )}

      {/* Bulk Upload Modal */}
      {showBulk && (
        <BulkMemberUploadModal
          onClose={() => setShowBulk(false)}
          onSuccess={handleBulkDone}
        />
      )}
    </div>
  );
}